
export enum ApiUrls {
    PROVIDERS = 'getProviders',
    BUSINESS_PARTNER_PROVIDERS = 'getBusinessPartnerProviders',
    ADMIN_USERS = 'getCopilotAdminUsers',
    CARRIERS = 'getCarriersCopilot',
    CARRIER_DRIVERS = 'getCarrierDriversCopilot',
    GET_AZUGA_CARRIER_DRIVERS = 'getAzugaCarrierDrivers',
    DRIVER_TRUCKS_MAP = 'getDriverTrucksMap',
    DRIVERS_METADATA_MAP = 'getDriversMetadataMap',
    GET_VERSION_POLICY = 'getVersionPolicy',
    ENABLED_CARRIERS = 'getEnabledCarriersCopilot',
    BUSINESS_PARTNERS = 'getCopilotBusinessPartners',
    ADD_BUSINESS_PARTNER = 'addCopilotBusinessPartner',
    UPDATE_BUSINESS_PARTNER = 'updateCopilotBusinessPartner',
    ADD_BUSINESS_PARTNER_PROVIDER = 'addBusinessPartnerProvider',
    UPDATE_BUSINESS_PARTNER_PROVIDER = 'updateBusinessPartnerProvider',
    DELETE_BUSINESS_PARTNER_PROVIDER = 'deleteBusinessPartnerProvider',
    TEST_BUSINESS_PARTNER_PROVIDER = 'testBusinessPartnerProvider',
    ADD_ADMIN_USER = 'addCopilotAdminUser',
    ADD_DRIVER = 'addDriverCopilot',
    ENABLE_DRIVER = 'enableDriverCopilot',
    DISABLE_DRIVER = 'disableDriverCopilot',
    CHANGE_ADMIN_USER_STATUS = 'changeCopilotAdminUserStatus',
    VALIDATE_CARRIER = 'validateCarrierCopilot',
    GET_AZUGA_CARRIERS = 'getAzugaCarriers',
    SET_AZUGA_CARRIER_STATUS = 'setAzugaCarrierStatus',
    ADD_AZUGA_DRIVER = 'addAzugaDriver',
    SET_AZUGA_DRIVER_STATUS = 'setAzugaDriverStatus',
    ENABLE_CARRIER = 'enableCarrierCopilot',
    DISABLE_CARRIER = 'disableCarrierCopilot',
    RESET_LOG_POINTER_FOR_DRIVER = 'resetLogPointerForDriver',
    SET_DRIVER_PASSWORD = 'setCopilotDriverPassword',
    SET_DRIVER_TRUCK_ID = 'setCopilotDriverTruckId',
    CLEAR_DRIVER_FLAGS = 'clearDriverFlags',

    // Exports
    EXPORT_RECENTLY_REGISTERED_DRIVERS = 'exportRecentlyRegisteredDrivers',
    EXPORT_ACCEPTED_OPTIMIZATIONS = 'exportAcceptedOptimizations',
    EXPORT_OPTIMIZATION_OPPORTUNITIES = 'exportOptimizationOpportunities',
}
